import { InterpolationWithTheme } from "@emotion/core";
import mq from "../mediaQuery";



export const labTestStyles: { [key: string]: InterpolationWithTheme<any> } = {
    labTestContainer: {
        display: "flex"
    },
    labTestNavHeaderText: {
        color: "rgb(0, 0, 0)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "18px"
    },
    searchBox: {
        background: "rgb(255, 255, 255)",
        borderRadius: "18px",
        border: "1px solid rgb(210, 210, 210)",
        padding: "5px 0px",
        textIndent: "10px",
        width: "95%",
        opacity: 0,
        [mq[0]]: {
            width: "95%"
        }
    },
    labtestLeftNav: {
        height: "100vh",
        padding: "20px",
        background: "lightgrey"
    },
    divider: {
        borderBottom: "1px solid rgb(182, 198, 215)"
    },
    searchIcon: {
        color: "rgb(255, 49, 109)",
        position: "relative",
        right: "25px",
        top: "3px",
        opacity: 0
    },
    activeTabOverride: {
        padding: "30px 0px"
    },

    leftNavConatiner: {
        background: "#ffffff",
        padding: 10,
        borderRight: "1px solid #b6c6d7",
        height: "calc(100vh - 60px)",
        overflowY: "scroll",
        width: 320,
        overflowX: "hidden",
        [mq[0]]: {
            width: "100%"
        }
    },
    viewPdfLink: {
        color: "#ff316d",
        fontFamily: " BrandonTextWeb-Medium",
        fontSize: "14px",
        fontWeight: 500,
        cursor: "pointer",
        marginLeft: "10px"
    },
    expandedLabTest: {
        background: " rgb(241, 245, 248)",
        borderRadius: "10px",
        [mq[0]]: {
            padding: "10px 0"
        }
    },
    dateText: {
        color: "rgba(0, 0, 0, 0.87)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: 18,
        fontWeight: 500,
        cursor: "pointer"
    },
    rightSection: {
        width: "100%"
    },
    rightHeader: {
        padding: 10,
        borderBottom: "1px solid #b6c6d7",
        margin: " 5px 0px"
    },
    tableHeader: {
        color: "rgb(51, 94, 144)",
        fontFamily: " BrandonTextWeb-Bold",
        fontSize: "14px",
        fontWeight: "bold"
    },
    tableCol: {
        width: "33%",
        [mq[0]]: {
            fontSize: "16px",
            padding: "0 10px"
        }
    },
    table: {
        width: "100%"
    },
    pdfIcon: {
        backgroundColor: "#ff316d",
        height: 150
    },
    iconText: {
        padding: "5px 2px",
        overflow: "auto"
    },
    iconsWrapper: {
        padding: "10px",
        display: "inline-block",
        background: "#e6e3e3",
        margin: "10px",
        textAlign: "center",
        color: "#ff316d",
        cursor: "pointer",
        width: 200
    },
    labtestLeftNavName: {
        cursor: "pointer",
        [mq[0]]: {
            textDecoration: "underline",
            margin: "5px 0"
        }
    },
    mobileFont: {
        [mq[0]]: {
            fontSize: "16px",
            padding: "0 10px"
        }
    },
    rightSideScroll: {
        height: "calc(100vh - 110px)",
        overflowY: "scroll",
        marginBottom: 20
    },
    labReportsContainer: {
        display: "flex",
        flexWrap: "wrap"
    }
}